import Api from "./base/api-base";

export default class WorkerDailyReportComformApi {

  list () {
    return Api.get({
      endpoint: Api.endpoint.worker_daily_report_comform
    });
  }
}